export default {
    types: {
        "ac_router": "AC-Router",
        "chair": "Stuhl",
        "desk": "Schreibtisch",
        "desktop": "Desktop",
        "desktop_riser": "Desktop-Riser",
        "detector": "Dampf- und Geräuschmelder",
        "displayport_cable": "Displayport-Kabel",
        "docking station": "Dockingstation",
        "dual_usb_adapter": "Dualband-USB-Adapter",
        "ear cushion": "Ohrpolster",
        "footrest": "Fußstütze",
        "hdmi_cable": "HDMI-Kabel",
        "hdmi_displayport_cable": "HDMI-auf-DisplayPort-Kabel",
        "hdmi_vga_cable": "HDMI-zu-VGA-Kabel",
        "headset": "Headset",
        "keyboard": "Tastatur",
        "kvm switch": "KVM-Schalter",
        "kvm_switch": "KVM-Schalter",
        "lamp": "Lampe",
        "laptop stand": "Laptopständer",
        "laptop": "Laptop",
        "mesh_router": "Mesh-Router",
        "monitor": "Monitor",
        "mouse": "Maus",
        "patch_cord": "Cat6-Patchkabel",
        "power": "Netzkabel",
        "power_center": "Kraftzentrum",
        "power_strip": "Steckdosenleiste",
        "printer": "Drucker",
        "smart_plug": "Smart Plug mini",
        "smart_power_strip": "Intelligente Steckdosenleiste",
        "speakerphone": "Freisprecheinrichtung",
        "stylus": "Stift",
        "tablet": "Tablette",
        "tablet accessory": "Tablet-Zubehör",
        "thunderbolt_cable": "USB-C auf Thunderbolt",
        "travel_router": "Reiserouter",
        "usb hub": "USB-Hub",
        "usb_adapter": "USB-Adapter",
        "usb_hub": "USB-Hub",
        "webcam": "Webcam"
    }
}